import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { NativeStorage } from '@ionic-native/native-storage';
import { Events } from 'ionic-angular';

import { BaseService } from './base-service';

import { API_TIMEOUT } from './config';

@Injectable()
export class UserService extends BaseService {
  authData = {
    token: null,
    userId: null,
    username: null
  }

  constructor(
    public http: Http,
    public nativeStorage: NativeStorage,
    public events: Events
    ) {
    super();
    console.log('Hello UserService Provider');
  }

  loadAuthData(opt = { onLaunch: false }) {
    // load data
    this.nativeStorage.getItem('authData')
      .then(
        data => {
          console.log('loadAuthData', data);
          if (data) {
            this.authData = JSON.parse(data);
            console.log('Found & Loaded authData!');
            if (opt.onLaunch) {
              console.log('START THIS OUT', data);
              this.events.publish('user:login');
            }
          }
        },
        error => console.error(error)
      );
  }

  setAuthData(data) {
    // preparing authData
    this.authData.userId = (data) ? data.userId : null;
    this.authData.username = (data) ? data.username : null;
    this.authData.token = (data) ? data.token : null;
    // saving data
    this.nativeStorage.setItem('authData', JSON.stringify(this.authData))
      .then(
        () => console.log('Saved authData!'),
        error => console.error('Error storing item', error)
      );
  }

  clearAuthData() {
    this.setAuthData(null);
  }

  getUserToken() {
    if ((this.authData.username != null) && (this.authData.token != null)) {
      return this.authData.token;
    }
    return null;
  }

  getAuthorizationHeaders() {
    const token = this.getUserToken();
    var headers = new Headers();
    headers.append('Content-Type', super.jsonContentType());
    // appending authorization header if possible
    if (token != null) {
      headers.append('Authorization', 'Bearer ' + token);
    }
    return headers;
  }

  authenticate(username: string, password: string) {
    const url = `${super.url()}/auth/login`;
    const params = { username: username.toLowerCase(), password };
    return this.http.post(url, params)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  persistPlaybackData(episodeId, progress) {
    const userId = this.authData.userId;
    const url = `${super.url()}/users/${userId}/playback`;
    const params = { episodeId, progress };
    const headers = { headers: this.getAuthorizationHeaders() };
    return this.http.put(url, params, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  fetchPlaybackData(episodeId) {
    const userId = this.authData.userId;
    const url = `${super.url()}/users/${userId}/playback?episodeId=${episodeId}`;
    const headers = { headers: this.getAuthorizationHeaders() };
    return this.http.get(url, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  fetchLastPlaybackData() {
    const userId = this.authData.userId;
    const url = `${super.url()}/users/${userId}/last-playback`;
    const headers = { headers: this.getAuthorizationHeaders() };
    return this.http.get(url, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/user-service.ts